import React from "react";
import {
  BicepsIcon,
  CheckCircleIcon,
  CheckIcon,
  XCircleIcon,
} from "../../images/icons/icons";

const FooterTags = ({ from, rowData }) => {
  const hasKey = (key) => rowData?.[key] !== undefined;

  const isTrialAssigned = rowData.three_day_assigned === 1;
  const isStuck = rowData.is_stuck === 1;
  const isTrainerAssgined = rowData?.trainer_id;

  return (
    <div className="live-subscription-membership-badges">
      {hasKey("type") ? (
        <div className="live-subscription-membership-badge plan">
          {rowData?.type === "addont_pt" ? "PT" : rowData?.type || "-"} Member
        </div>
      ) : null}

      {from !== "new_subscription" && hasKey("three_day_assigned") ? (
        <div
          className={`live-subscription-membership-badge ${
            isTrialAssigned ? "assigned" : "not-assigned"
          }`}
        >
          {isTrialAssigned ? (
            <>
              <CheckCircleIcon size={14} />
              PT Trial Assigned
            </>
          ) : (
            <>
              <XCircleIcon size={14} />
              PT Trial Not Assigned
            </>
          )}
        </div>
      ) : null}

      {hasKey("three_day_done_count") && isTrialAssigned ? (
        <div className="live-subscription-membership-badge plan">
          {rowData?.three_day_done_count || 0} / 3 session Done
        </div>
      ) : null}

      {hasKey("trainer_id") ? (
        <div
          className={`live-subscription-membership-badge ${
            isTrainerAssgined ? "assigned" : "not-assigned"
          }`}
        >
          {isTrainerAssgined ? (
            <BicepsIcon color="#166534" />
          ) : (
            <BicepsIcon color="#b91c1c" />
          )}

          {isTrainerAssgined ? "trainer assigned" : "trainer not assigned"}
        </div>
      ) : null}

      {hasKey("bca_status") && isTrialAssigned ? (
        <div className="live-subscription-membership-badge plan">
          BCA - {rowData?.bca_status || "-"}
        </div>
      ) : null}

      {hasKey("is_stuck") && isTrialAssigned ? (
        <div
          className={`live-subscription-membership-badge ${
            isStuck ? "stuck" : "assigned"
          }`}
        >
          {isStuck ? <XCircleIcon size={14} /> : <CheckIcon color="#166534" />}

          {isStuck
            ? `Trial is Stuck - ${
                rowData?.stuck_time?.replace(/_/g, " ") || ""
              }`
            : "Trial is on track"}
        </div>
      ) : null}
    </div>
  );
};

export default FooterTags;
